import React from 'react';
import Page from '../components/Page';
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Label,
  Row,
  Form,
  FormFeedback,
  FormGroup,
  FormText,
  Input,
  Table,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from 'reactstrap';
import Avatar from '../components/Avatar';
import user1Image from '../assets/img/users/100_1.jpg';
import {
  MdEdit,
  MdFormatListBulleted,
  MdFlag,
  MdLanguage,
  MdHome,
  MdAdd,
  MdCameraAlt,
} from 'react-icons/md';
import classnames from 'classnames';
import OrganisationForm from '../components/OrganisationForm';
import { Redirect } from 'react-router';
import StorageService from '../services/StorageService';
import userPlaceholder from '../assets/img/users/placeholder.jpg';
import NotificationSystem from 'react-notification-system';
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants';

class OrganisationDetailsPage extends React.Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      activeTab: '1',
      hidden: false,
      redirect: false,
      details: {},
      modal: false,
    };
  }

  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  }

  toggleModal = modalType => () => {
    if (!modalType) {
      return this.setState({
        modal: !this.state.modal,
      });
    }

    this.setState({
      [`modal_${modalType}`]: !this.state[`modal_${modalType}`],
    });
  };

  closeModal = (title, message, level, reload) => {
    this.notificationSystem.addNotification({
      title: title,
      message: message,
      level: level,
      position: 'br',
      autoDismiss: 2,
      dismissible: 'click',
    });

    this.setState({
      modal: false,
    });

    if (reload) {
      window.location.reload();
    }
  };

  componentDidMount() {
    if (this.props.location.data == undefined) {
      this.setState({ redirect: true });
    } else {
      this.setState({
        details: this.props.location.data,
      });
    }
  }

  render() {
    console.log(this.props);
    const { activeTab, redirect, details } = this.state;

    if (redirect) {
      return <Redirect to="/" />;
    }

    return (
      <Page
        className="DetailsPage"
        title="Details"
        breadcrumbs={[
          { name: 'Organisation', active: false },
          { name: 'Details', active: true },
        ]}
      >
        <NotificationSystem
          dismissible={false}
          ref={notificationSystem =>
            (this.notificationSystem = notificationSystem)
          }
          style={NOTIFICATION_SYSTEM_STYLE}
        />
        <Form onSubmit={this.handleSubmit} className="AuthForm">
          <Row>
            <Col xl={3} lg={3} md={12}>
              <Card style={{ height: '100%' }}>
                <CardBody>
                  <div className="text-center">
                    <Label>Organisation Logo</Label>
                    {details.companyLogo === null ||
                    details.companyLogo === '' ? (
                      <Avatar
                        src={userPlaceholder}
                        size="30"
                        className="mb-2 profile-img"
                      />
                    ) : (
                      <Avatar
                        src={details.companyLogo}
                        size="30"
                        className="mb-2 profile-img"
                        style={{ width: '100px', height: '100px' }}
                      />
                    )}
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col xl={9} lg={9} md={12}>
              <Card style={{ height: '100%' }}>
                <CardBody>
                  <div className="text-right">
                    <Button
                      className="theme-button theme-button-transparent"
                      onClick={this.toggleModal()}
                    >
                      <MdEdit />
                      Edit
                    </Button>
                  </div>
                  <Row form>
                    <Col lg={6}>
                      <Label>Name</Label>
                      <p>{details.companyName}</p>
                    </Col>
                    <Col lg={6}>
                      <Label>Business Type</Label>
                      <p>{details.businessType}</p>
                    </Col>
                  </Row>
                  <Row form>
                    <Col lg={3}>
                      <Label>HQ Country</Label>
                      <p>{details.country}</p>
                    </Col>
                    <Col lg={3}>
                      <Label>Base Currency</Label>
                      <p>{details.baseCurrency}</p>
                    </Col>
                    <Col lg={6}>
                      <Label>URL</Label>
                      <p>
                        {details.companyURL === null ||
                        details.companyURL === ''
                          ? 'None'
                          : details.companyURL}
                      </p>
                    </Col>
                  </Row>
                </CardBody>
              </Card>

              <Modal
                isOpen={this.state.modal}
                toggle={this.toggleModal()}
                className={this.props.className}
                style={{ maxWidth: '700px' }}
                centered
              >
                <OrganisationForm
                  history={this.props.history}
                  viewState={this.props.viewState}
                  onToggleModal={this.toggleModal}
                  closeModal={this.closeModal}
                  data={this.props.location.data}
                />
              </Modal>
            </Col>
          </Row>

          <Row>
            <Col xl={12} lg={12} md={12}>
              <Card>
                <CardBody>
                  <Row form>
                    <Col lg={3}>
                      <Label>Industry</Label>
                      <p>
                        {details.industry === null || details.industry === ''
                          ? 'None'
                          : details.industry}
                      </p>
                    </Col>
                    <Col lg={3}>
                      <Label>Sub-Industry</Label>
                      <p>
                        {details.subIndustry === null ||
                        details.subIndustry === ''
                          ? 'None'
                          : details.subIndustry}
                      </p>
                    </Col>
                  </Row>

                  <Row form>
                    <Col lg={3}>
                      <Label>Stock Exchange</Label>
                      <p>
                        {details.stockExchange === null ||
                        details.stockExchange === ''
                          ? 'None'
                          : details.stockExchange}
                      </p>
                    </Col>
                    <Col lg={3}>
                      <Label>Stock Symbol</Label>
                      <p>
                        {details.stockSymbol === null ||
                        details.stockSymbol === ''
                          ? 'None'
                          : details.stockSymbol}
                      </p>
                    </Col>
                    <Col lg={3}>
                      <Label>Stock Currency</Label>
                      <p>
                        {details.stockCurrency === null ||
                        details.stockCurrency === ''
                          ? 'None'
                          : details.stockCurrency}
                      </p>
                    </Col>
                  </Row>
                  <Row form>
                    <Col lg={3}>
                      <Label>Division</Label>
                      <p>
                        {details.division === null || details.division === ''
                          ? 'None'
                          : details.division}
                      </p>
                    </Col>
                    <Col lg={3}>
                      <Label>Region</Label>
                      <p>
                        {details.regionName === null ||
                        details.regionName === ''
                          ? 'None'
                          : details.regionName}
                      </p>
                    </Col>
                    <Col lg={3}>
                      <Label>Business Entity</Label>
                      <p>
                        {details.businessEntity === null ||
                        details.businessEntity === ''
                          ? 'None'
                          : details.businessEntity}
                      </p>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Form>
        <Form onSubmit={this.handleSubmit} className="AuthForm">
          <Row>
            <Col xl={12} lg={12} md={12}>
              <Card>
                <CardBody>
                  <Row form>
                    <Col lg={12}>
                      <div className="d-md-flex align-items-center">
                        <Label>Child Organisation</Label>
                        <div className="d-flex ml-auto mb-3">
                          <Input type="select" name="role">
                            <option>Org 1</option>
                            <option>Org 2</option>
                            <option>Org 3</option>
                            <option>Org 4</option>
                            <option>Org 5</option>
                          </Input>
                          <Button className="theme-button theme-button-transparent">
                            <MdAdd />
                            Add
                          </Button>
                        </div>
                      </div>
                    </Col>
                  </Row>

                  <Nav tabs>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === '1' })}
                        onClick={() => {
                          this.toggle('1');
                        }}
                      >
                        <MdFormatListBulleted />
                        List
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === '2' })}
                        onClick={() => {
                          this.toggle('2');
                        }}
                      >
                        <MdHome />
                        Division
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === '3' })}
                        onClick={() => {
                          this.toggle('3');
                        }}
                      >
                        <MdFlag />
                        Country
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === '4' })}
                        onClick={() => {
                          this.toggle('4');
                        }}
                      >
                        <MdLanguage />
                        Region
                      </NavLink>
                    </NavItem>
                  </Nav>
                  <TabContent activeTab={activeTab}>
                    <TabPane tabId="1" className="py-3">
                      <Row>
                        <Col sm={12}>
                          <div className="tab-pane-content">
                            <Table
                              responsive
                              hover
                              className="ps-table tb-col-5"
                            >
                              <thead>
                                <tr>
                                  <th>Name</th>
                                  <th>Country</th>
                                  <th>Type</th>
                                  <th>Industry</th>
                                  <th>Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td>Jacob</td>
                                  <td>Thornton</td>
                                  <td>@fat</td>
                                  <td>Otto</td>
                                  <td></td>
                                </tr>
                              </tbody>
                            </Table>
                          </div>
                        </Col>
                      </Row>
                    </TabPane>
                    <TabPane tabId="2" className="py-3">
                      <Row>
                        <Col sm={12}>
                          <div className="tab-pane-content">
                            <Table
                              responsive
                              hover
                              className="ps-table tb-col-5"
                            >
                              <thead>
                                <tr>
                                  <th>Name</th>
                                  <th>Country</th>
                                  <th>Type</th>
                                  <th>Industry</th>
                                  <th>Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td>Jacob</td>
                                  <td>Thornton</td>
                                  <td>@fat</td>
                                  <td>Otto</td>
                                  <td></td>
                                </tr>
                              </tbody>
                            </Table>
                          </div>
                        </Col>
                      </Row>
                    </TabPane>
                    <TabPane tabId="3">
                      <Row>
                        <Col sm={12}>
                          <div className="tab-pane-content"></div>
                        </Col>
                      </Row>
                    </TabPane>
                    <TabPane tabId="4">
                      <Row>
                        <Col sm={12}>
                          <div className="tab-pane-content"></div>
                        </Col>
                      </Row>
                    </TabPane>
                  </TabContent>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Form>
      </Page>
    );
  }
}
export default OrganisationDetailsPage;
